var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tick",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.098 7.38967L9.93797 14.2997L8.03797 12.2697C7.68797 11.9397 7.13797 11.9197 6.73797 12.1997C6.34797 12.4897 6.23797 12.9997 6.47797 13.4097L8.72797 17.0697C8.94797 17.4097 9.32797 17.6197 9.75797 17.6197C10.168 17.6197 10.558 17.4097 10.778 17.0697C11.138 16.5997 18.008 8.40967 18.008 8.40967C18.908 7.48967 17.818 6.67967 17.098 7.37967V7.38967Z",
    fill: "#4440CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepComplete);
export default __webpack_public_path__ + "static/media/stepComplete.266b208daeab3ca31ffdae66f24a575a.svg";
export { ForwardRef as ReactComponent };